import {Box, Link, Typography} from "@mui/material"
import {FC} from "react"
import {ClimbingEvent} from "../../../models/ClimbingEvent"
import {checkIfDateWasInPast, dateAsString} from "../../../services/time/TimeService"
import {useTranslation} from "react-i18next";
import banner from "../../../images/banner.jpg"

type Props = {
  event: ClimbingEvent,
  menuElement: React.ReactElement
}

export const EventResultComponent: FC<Props> = ({event, menuElement}) => {
  const {t} = useTranslation()

  return (
    <>
           <Typography align="center" variant="h6" m={1}>{event.name}</Typography>
          {/*<Box sx={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection:"column", gap: 1}}>*/}
          {/*  <img height={155} src={banner} alt={t('logo') || ""}/>*/}
          {/*</Box>*/}
      {!checkIfDateWasInPast(event.endDate) &&
        (<>
            {menuElement}

          </>
        )}

      {checkIfDateWasInPast(event.endDate) && <Typography variant="h6"
                                                          align="center">{t('event.eventEnded')} {!event.resultsLink && ", " + t('event.resultsAvailableSoon')}</Typography>}

      <Box sx={{display: "flex", justifyContent: "space-around", mb: 1, mt: 1}}>
        {event.resultsLink && <Link target="_blank" href={event.resultsLink}>{t('event.results')}</Link>}
        {event.moreInfoLink && <Link target="_blank" href={event.moreInfoLink}>{t('event.moreInfo')}</Link>}
      </Box>

      <Box sx={{display: "flex", justifyContent: "space-around", mb: 1, mt: 1}}>
        <Typography>{dateAsString(event.startDate)} - {dateAsString(event.endDate)}</Typography>
      </Box>
    </>

  )
}